/* Delegated cart preview: works after quantity updates and drawer section replacements. */
(() => {
  if (window.__tnzCartDesignPopup) return;window.__tnzCartDesignPopup = true;
  let dialog, image, opener, overflow;
  function ensure() {
    if (dialog?.isConnected) return;
    dialog=document.createElement('dialog');dialog.className='tnz-design-dialog';dialog.setAttribute('aria-labelledby','tnz-design-dialog-title');
    const heading=document.createElement('h2');heading.id='tnz-design-dialog-title';heading.textContent='Your design';
    const close=document.createElement('button');close.type='button';close.className='tnz-design-dialog__close';close.setAttribute('aria-label','Close design preview');close.textContent='×';close.addEventListener('click',()=>dialog.close());
    image=document.createElement('img');image.alt='Your personalized design';image.width=image.height=400;
    dialog.append(heading,close,image);document.body.append(dialog);
    dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();});
    dialog.addEventListener('close',()=>{document.body.style.overflow=overflow;if(opener?.isConnected)opener.focus({preventScroll:true});});
  }
  document.addEventListener('click',event=>{
    const link=event.target.closest('a[data-tnz-design-preview]');
    if(!link||event.defaultPrevented||event.button!==0||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey||!window.HTMLDialogElement)return;
    let url;try{url=new URL(link.href);}catch{return;}
    if(url.protocol!=='https:'||url.hostname!=='cdn.shopify.com')return;
    event.preventDefault();ensure();opener=link;image.src=url.href;
    if(!dialog.open){overflow=document.body.style.overflow;document.body.style.overflow='hidden';dialog.showModal();}
  });
})();
